// Endpoints do módulo workflow-engine (blueprint /api/v1/workflow-engine,
// api.yaml spec-003). Sem hardcode no api layer — tudo aqui.

const PREFIX = '/api/v1/workflow-engine'

export const URL = {
  // Registry (US-1) — INTERNO, escopado por sessão.
  triggers: `${PREFIX}/trigger`,
  trigger: (id) => `${PREFIX}/trigger/${id}`,
  triggerActive: (id) => `${PREFIX}/trigger/${id}/active`,
  triggerTestFire: (id) => `${PREFIX}/trigger/${id}/test-fire`,

  // Workflows (spec-004 canvas) — INTERNO, escopado por sessão. CRUD + run.
  workflows: `${PREFIX}/workflow`,
  workflow: (id) => `${PREFIX}/workflow/${id}`,
  workflowRun: (id) => `${PREFIX}/workflow/${id}/run`,
  workflowExecutions: (id) => `${PREFIX}/workflow/${id}/execution`,

  // Execuções — detalhe de UMA execução (run_data por nó).
  execution: (id) => `${PREFIX}/execution/${id}`,

  // Catálogo de tipos de nó disponíveis para montar o grafo.
  catalog: `${PREFIX}/catalog`,

  // Form (US-3/US-5) — autenticado (profissional/gestor); o backend valida a
  // sessão + office-match do token (SSOT) — o frontend NUNCA envia office/workflow (US-8).
  form: (token) => `${PREFIX}/form/${token}`,
}
